import React from "react";
import BaseGrid from "Components/Fragment/BaseGrid";
import { Badge } from "Components/Base/DataDisplay/Badge";
import TotalProgressSection from "./components/TotalProgressSection";
import DrawerFilters from "./components/DrawerFilters";
import ToggleButtonGroupFilter from "./components/ToggleButtonGroupFilter";
import ToggleButtonGroupViewType from "../ToggleButtonGroupViewType";
import { useFilter } from "./context";

const MobileFilter = ({ languageContext }) => {
  const { hitCount } = useFilter();

  return (
    <>
      <BaseGrid
        alignItems="center"
        justifyContent="space-between"
        childWidth="auto"
      >
        <Badge badgeContent={hitCount ?? 0} color="primary">
          <ToggleButtonGroupFilter languageContext={languageContext} />
        </Badge>
        <ToggleButtonGroupViewType
          labels={[languageContext("ListView"), languageContext("imageview")]}
        />
        <TotalProgressSection languageContext={languageContext} scale={0.8} />
      </BaseGrid>

      <DrawerFilters languageContext={languageContext} mobile={true} />
    </>
  );
};

export default MobileFilter;
